import { render, staticRenderFns } from "./EditMilestoneModal.vue?vue&type=template&id=2d1a9d37"
import script from "./EditMilestoneModal.vue?vue&type=script&lang=ts"
export * from "./EditMilestoneModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1a9d37')) {
      api.createRecord('2d1a9d37', component.options)
    } else {
      api.reload('2d1a9d37', component.options)
    }
    module.hot.accept("./EditMilestoneModal.vue?vue&type=template&id=2d1a9d37", function () {
      api.rerender('2d1a9d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/EditMilestoneModal.vue"
export default component.exports